    // Toggle function for the hamburger menu
    function togglePopup() {
      const drawer = document.getElementById('drawerOverlay');
      drawer.classList.toggle('open');
      document.body.classList.toggle('no-scroll');
    }
    // Change logo on scroll
    window.addEventListener('scroll', function() {
    const header = document.querySelector('.custom-header');
    const logo = document.querySelector('.logo-image');
    const hamburger = document.querySelector('.hamburger');



    if (window.scrollY > 200) {
      header.classList.add('scrolled'); // Add the scrolled class to header
      logo.src = "https://cdn.shopify.com/s/files/1/0592/3405/8445/files/Logo-blck2.svg?v=1729902534"; // Change logo to black
      hamburger.style.color = "#000";


      
      
    } else {
      header.classList.remove('scrolled'); // Remove the scrolled class
      logo.src = "https://cdn.shopify.com/s/files/1/0592/3405/8445/files/Logo_b152d725-ba56-4fdf-adb6-e25552f276e8.svg?v=1729903336";
      hamburger.style.color = "#FFF";

    }
  });

  // Function to add or remove the fixed position on scroll based on header height
  function handleScroll() {
      const header = document.querySelector('.custom-header');
      if (!header) return; // Exit if .custom-header is not found

      const headerHeight = header.offsetHeight; // Get the height of .custom-header

      if (window.scrollY > headerHeight) {
          header.style.position = 'fixed';
          header.style.top = '0';
          header.style.width = '100%';
          header.style.backgroundColor = 'rgba(255, 255, 255, 0.7)';
          header.style.backdropFilter = 'blur(10px)'; // Apply 10px background blur
          header.style.webkitBackdropFilter = 'blur(10px)';
      } else {
          header.style.position = 'relative';
          header.style.backgroundColor = '';
      }
  }

  // Check if device is mobile and then add scroll listener
  if (window.innerWidth <= 768) {

      window.addEventListener('scroll', handleScroll);
  }